require( 'es5-shim' );
require( 'es5-shim/es5-sham' );


// WEBPACK FOOTER //
// ./client/ie-shims.js